'use client'
import Link from 'next/link'
import { usePathname } from 'next/navigation'
import { FC } from 'react'

type NavLinkProps = {
  href: string
  title: string
  exact?: boolean
}

const NavLink: FC<NavLinkProps> = ({ href, title, exact = false }) => {
  const pathname = usePathname()
  const isActive = exact ? pathname === href : pathname.startsWith(href)
  const navLinkClassName = 'py-[18px] px-6 border rounded-[25px] text-white m-0 leading-[11px] hover:bg-KMRSx24-Orange hover:border-KMRSx24-Orange'
  const newClassName = isActive ? `${navLinkClassName} bg-KMRSx24-Orange border-KMRSx24-Orange` : `${navLinkClassName} bg-transparent border-white`

  return (
    <li className="flex">
      <Link href={href} className={newClassName}>
        {title}
      </Link>
    </li>
  )
}

export default NavLink
